const RAID_ELEMENTS = new Set(['작열', '수냉', '전격', '풍압', '철갑']);

const KNOWN_BOSS_IMAGES = {
  두리안: 'https://cdn.jsdelivr.net/gh/ddssh1056/nikkeRaid@main/Enemy_Mace.webp',
  알트아이젠: 'https://sg-tools-cdn.blablalink.com/li-43/mc-14/f64acd96d0c3776366b71914283e9e1a.webp',
  크라켄: 'https://static.wikia.nocookie.net/nikke-goddess-of-victory-international/images/5/55/Enemy_Kraken_%28P.S.I.D.%29.png',
};

function text(value) {
  return String(value ?? '').trim();
}

function cleanBossName(value) {
  let result = text(value);
  for (let index = 0; index < 5; index += 1) {
    const before = result;
    result = result.replace(/\s*[\[\(（［【]\s*[A-Za-z0-9 ._:\-]+\s*[\]\)）］】]\s*$/g, '').trim();
    result = result.replace(/\s+(?:[A-Z]\.){2,}[A-Z]?\.?\s*$/g, '').trim();
    if (result === before) break;
  }
  return result;
}

export function normalizeCollectedBossMetadata(rawBosses = []) {
  const map = new Map();
  for (const raw of Array.isArray(rawBosses) ? rawBosses : []) {
    const bossNo = Number(raw?.bossNo ?? raw?.boss_no);
    const bossName = cleanBossName(raw?.bossName ?? raw?.boss_name);
    const element = text(raw?.element);
    if (!Number.isInteger(bossNo) || bossNo < 1 || bossNo > 5 || !bossName || !RAID_ELEMENTS.has(element)) continue;
    map.set(bossNo, {
      bossNo,
      bossName,
      element,
      bossId: text(raw?.bossId ?? raw?.boss_id),
      iconId: text(raw?.iconId ?? raw?.icon_id),
      monsterModelId: text(raw?.monsterModelId ?? raw?.monster_model_id),
    });
  }
  return [...map.values()].sort((a, b) => a.bossNo - b.bossNo);
}

export function mergeCollectedBossMetadata(existingBosses = [], collectedBosses = []) {
  const metadata = new Map(normalizeCollectedBossMetadata(collectedBosses).map((boss) => [boss.bossNo, boss]));
  let changedCount = 0;
  const bosses = (Array.isArray(existingBosses) ? existingBosses : []).map((boss) => {
    const bossNo = Number(boss?.boss_no ?? boss?.bossNo);
    const collected = metadata.get(bossNo);
    if (!collected) return boss;
    const nextImage = KNOWN_BOSS_IMAGES[collected.bossName] || text(boss?.image_url ?? boss?.imageUrl);
    const changed = text(boss?.boss_name ?? boss?.bossName) !== collected.bossName
      || text(boss?.element) !== collected.element
      || text(boss?.image_url ?? boss?.imageUrl) !== nextImage;
    if (changed) changedCount += 1;
    return {
      ...boss,
      boss_no: bossNo,
      boss_name: collected.bossName,
      element: collected.element,
      image_url: nextImage,
    };
  });
  return { bosses, changedCount, collectedCount: metadata.size };
}
